/**
 * Backend stores two credentials per user: main `password` (trade) and `view password` (read-only).
 * Login uses the same `/user/login` endpoint; the API/JWT indicates view-only via flags
 * (same idea as old web: `isMasterRole === false` → "View Only", no orders).
 */

function isTruthy(v) {
  return v === true || v === 1 || v === "1" || v === "true" || v === "True" || v === "Yes";
}

function isFalsy(v) {
  return v === false || v === 0 || v === "0" || v === "false" || v === "False" || v === "No";
}

/**
 * @param {object} apiData - `data.data` from login response
 * @param {object} jwt - decoded access token payload
 * @param {{ defaultMasterRole?: boolean }} [opts] - default when API omits flags (main-password legacy)
 * @returns {boolean} - true = may trade; false = view-only (view password or equivalent)
 */
export function resolveIsMasterRoleFromLoginPayload(apiData = {}, jwt = {}, opts = {}) {
  const defaultMasterRole = opts.defaultMasterRole !== false;

  const viewOnly =
    apiData.isViewOnly ??
    apiData.IsViewOnly ??
    apiData.viewOnlyLogin ??
    apiData.ViewOnlyLogin ??
    jwt.isViewOnly ??
    jwt.IsViewOnly ??
    jwt.viewOnlyLogin ??
    jwt.ViewOnlyLogin;

  if (isTruthy(viewOnly)) return false;

  const master =
    apiData.isMasterRole ??
    apiData.IsMasterRole ??
    jwt.isMasterRole ??
    jwt.IsMasterRole;

  if (isFalsy(master)) return false;
  if (isTruthy(master)) return true;

  return defaultMasterRole;
}

/** Session object from `fxbazzar_user` / `getSessionData()` — `isMasterRole === false` means view-only. */
export function isSessionTradingAllowed(session) {
  if (!session || typeof session !== "object") return true;
  return session.isMasterRole !== false;
}
